import { render, staticRenderFns } from "./MyGalleryFoot.vue?vue&type=template&id=ac047494&scoped=true&"
import script from "./MyGalleryFoot.vue?vue&type=script&lang=js&"
export * from "./MyGalleryFoot.vue?vue&type=script&lang=js&"
import style0 from "./MyGalleryFoot.vue?vue&type=style&index=0&id=ac047494&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac047494",
  null
  
)

export default component.exports